$(() => {
  const passwordInput = $('#password-input-group > input.password');
  const passwordIcon = $('#password-input-group > .password-toggle');
  const newPasswordInput = $('#password-input-group > input.new-password');

  const showPassword = (input, icon) => {
    icon.on('click', () => {
      const inputType = input.attr('type');

      switch (inputType) {
        case 'text':
          input.attr('type', 'password');
          icon.find('#show-password').switchClass('d-none', 'd-flex');
          icon.find('#hide-password').switchClass('d-flex', 'd-none');
          break;
        case 'password':
          input.attr('type', 'text');
          icon.find('#show-password').switchClass('d-flex', 'd-none');
          icon.find('#hide-password').switchClass('d-none', 'd-flex');
          break;
      }
    });
  };
  showPassword(passwordInput, passwordIcon);
  showPassword(newPasswordInput, passwordIcon);
});
